package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.preview.PreviewSurface
import com.bikompanion.ui.strings.LocalStrings

/**
 * Says a network's stations are on their way, for a network with nothing drawn yet.
 *
 * Only the first load of a network gets it. Later refreshes already have the countdown pill, and
 * a spinner on top of stations that are already on screen would only flicker.
 */
@Composable
internal fun StationsLoadingIndicator(
    isLoading: Boolean,
    modifier: Modifier = Modifier,
) {
    if (!isLoading) return
    LoadingPill(text = LocalStrings.current.stationsLoading, modifier = modifier)
}

@Preview
@Composable
private fun StationsLoadingIndicatorPreview() {
    PreviewSurface {
        StationsLoadingIndicator(isLoading = true, modifier = Modifier.padding(16.dp))
    }
}

@Preview
@Composable
private fun StationsLoadingIndicatorHiddenPreview() {
    PreviewSurface {
        StationsLoadingIndicator(isLoading = false, modifier = Modifier.padding(16.dp))
    }
}
